import { useTranslation } from "react-i18next"
import { DotPill, Tone } from "../../delivery/atoms"

const TONES: Record<string, Tone> = {
  DRAFT: "grey",
  INITIATED: "amber",
  SENDER_VERIFIED: "amber",
  RECEIVER_VERIFIED: "blue",
  COMPLETED: "green",
  CANCELLED: "grey",
}

interface Props {
  status: string | null | undefined
  /** Kept for call-site compatibility; the pill has one size. */
  size?: unknown
}

/** Handover status as a dot pill (canvas Ord_HandoverDetail «Илгээгч баталсан»). */
export function CustodyStatusBadge({ status }: Props) {
  const { t } = useTranslation("delivery")
  if (!status) return <>-</>
  return <DotPill tone={TONES[status] ?? "grey"}>{t(`custody.status.${status}`, { defaultValue: "-" })}</DotPill>
}
